import { core } from '@/core'
import Basic from '@basic'

const util = {
  template: {
    radio() {
      return $(`
      <label class="lt-radio">
        <span id="box" class="radio__input">
          <span id="inner" class="radio__inner"></span>
          <input id="input" class="radio__original" type="radio" aria-hidden="true" tabindex="-1">
        </span>
        <span id="label" class="radio__label"></span>
      </label>`)
    },
    radioButton() {
      return $(`
      <label class="radio-button" role="radio">
        <input class="radio-button__orig-radio" type="radio" tabindex="-1">
        <span class="radio-button__inner"></span>
      </label>`)
    },
  },
  updater: {
    // 原生属性√: name
    name(value, opt, tar, node) {
      const { input } = tar.members
      if (value) {
        input.attr('name', value)
      } else {
        input.removeAttr('name')
      }
    },
    // 基本功能: 是否选中
    checked(value, opt, tar, node) {
      const { input, box } = tar.members
      if (value || value === '') {
        box.addClass('is-checked')
        input.prop('checked', true)
      } else {
        box.removeClass('is-checked')
        input.prop('checked', false)
      }
    },
    // 原生属性√: disabled
    disabled(value, opt, tar, node) {
      const { input, box } = tar.members
      if (value || value === '') {
        box.addClass('is-disabled')
        input.prop('disabled', true)
      } else {
        box.removeClass('is-disabled')
        input.prop('disabled', false)
      }
    },
    // 基本功能: 是否显示边框
    border(value, opt, tar, node) {
      if (value || value === '') {
        tar.unit.addClass('is-bordered')
      } else {
        tar.unit.removeClass('is-bordered')
      }
    },
    // 基本功能√: 值
    value(value, opt, tar, node) {
      const { input } = tar.members
      input.attr('value', value)
    },
    // 基本功能√: 尺寸
    size(value, opt, tar, node) {
      value &&
        tar.unit.removeClass('input-size--*').addClass(`input-size--${value}`)
    },
    // 基本功能: 选中状态的值
    label(value, opt, tar, node) {
      const { box, label } = tar.members
      if (!box) return
      if (value) {
        label.before(box).html(value)
      } else {
        label.detach()
      }
    },
  },
}

export default class Radio extends Basic {
  constructor(opt) {
    super(opt)
    this.defaults = {
      name: '', // 原生属性: name
      checked: false, // 原生属性: 是否选中
      disabled: false, // 原生属性: 禁用(true/false)

      border: false, // 基本功能: 是否显示边框
      value: '', // 基本功能: 值
      size: '', // 基本功能: 尺寸
      label: '', // 基本功能: 选中状态的值
    }
    this.events = {
      change: 'onChange',
      click: 'onClick',
    }
    core.proxyApi(this) // 核心属性处理
    core.proxyEvent(this) // 核心事件处理
    this.settings = Object.assign({}, this.defaults, opt)
    this.init()
  }

  init() {
    const opt = this.settings
    const { type } = opt
    let template
    if (type === 'button') template = util.template.radioButton(opt, this)
    else template = util.template.radio(opt, this)
    const members = {}
    core.compileSymbol(template[0], members)
    this.members = members
    this.unit = template
    core.update(util.updater, opt, this)
    this.bindInput()
  }

  destroyed() {
    this.unit.empty().remove()
  }

  bindInput() {
    const { input } = this.members
    input.on('change', $.proxy(this.change, this))
    input.on('click', $.proxy(this.click, this))
  }

  onChange(e) {
    if (!e || !e.target) {
      this.members.input.change()
      this.checked = !this.checked
      return false
    }
  }

  onClick(e) {
    if (!e || !e.target) {
      this.members.input.click()
      if (this.checked !== this.members.input.prop('checked')) {
        this.members.input.change()
      }
      return false
    }
    this.checked = true
  }
}
